import { render, staticRenderFns } from "./HomologationWarningBadge.vue?vue&type=template&id=2cdabd8e"
import script from "./HomologationWarningBadge.vue?vue&type=script&lang=js"
export * from "./HomologationWarningBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports